import { useMemo } from 'react'

interface Particle {
  id: number
  size: number
  left: string
  top: string
  delay: number
  duration: number
  opacity: number
}

export function FloatingParticles() {
  const particles = useMemo(() => {
    const particleCount = 10
    const generated: Particle[] = []

    for (let i = 0; i < particleCount; i++) {
      generated.push({
        id: i,
        size: Math.random() * 3 + 1, // 1-4px
        left: `${Math.random() * 100}%`,
        top: `${Math.random() * 100}%`,
        delay: Math.random() * 5,
        duration: Math.random() * 10 + 10, // 10-20s
        opacity: Math.random() * 0.2 + 0.2, // 0.3-0.8
      })
    }

    return generated
  }, [])

  return (
    <div className="pointer-events-none absolute left-[10vw] right-[10vw] top-[5vh] z-0 h-[30vh] overflow-hidden">
      {particles.map((particle) => (
        <div
          key={particle.id}
          className="particle absolute rounded-full bg-white"
          style={{
            width: `${particle.size}px`,
            height: `${particle.size}px`,
            left: particle.left,
            top: particle.top,
            opacity: particle.opacity,
            animation: `float ${particle.duration}s ease-in-out infinite`,
            animationDelay: `${particle.delay}s`,
            boxShadow: '0 0 10px rgba(255, 255, 255, 0.5)',
          }}
        />
      ))}
    </div>
  )
}
